module.exports = __webpack_public_path__ + "img/Logo-Radio-Papilles.3ca43bf.png";